import React from 'react';
import PropTypes from 'prop-types';
import { contextsColors } from '../config';

const colors = { F : contextsColors[0], M : contextsColors[1], C : contextsColors[2], I : contextsColors[3] };


export default function Check({ value, name, visible, onChangeFcn }) {

    let className = 'text-small check';
    if(!visible) className = 'hide';

    return (
        <label className={className} style={{ border: `2px solid #${colors[value]}` }}>
            <input type="checkbox" id={value} value={value} onChange={onChangeFcn} style={{ accentColor: `#${colors[value]}` }}/> { name }
        </label>
    )
}

Check.propTypes = {
    value: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    visible: PropTypes.bool.isRequired,
    onChangeFcn: PropTypes.func
};
